import React, { FC } from "react";
import { TableHead as MuiTableHead } from "@mui/material";

type Props = React.ComponentProps<typeof MuiTableHead>;

const TableHead: FC<Props> = (props) => {
    return <MuiTableHead {...props}/>
}

export default TableHead;